/* ============================================================================
   bt-minitools.js  ·  ALLE interaktiven Tools der Ratgeberseiten
   Einbindung im Artikeltext ueber ein leeres div mit data-bt-modul.
   Namen: rechner-sicherheitsstufe, gradpicker, feuerschutzklasse, schloss,
   waffenklasse, platz-check, groesse, liefervergleich.

   Das Grundgeruest (Registry, Tracking, Kopfzeile, Init) steht in
   bt-ratgeber-calc.js.

   WICHTIG: In diesem File NIEMALS typografische Anfuehrungszeichen verwenden.
   Sie haben beim Upload schon einmal die Datei zerlegt.

   FACHLICH WICHTIG 1: Die Temperaturwerte der Feuerschutznormen sind DELTA-
   Werte, also der zulaessige Anstieg im Innenraum gegenueber der Start-
   temperatur. Nie als Materialeigenschaft formulieren.

   FACHLICH WICHTIG 2: Wir geben KEINE Statik-Freigabe, aber wir machen daraus
   auch keine Drohkulisse. Ton: etwas, das man beachtet und pruefen laesst, wie
   die Tuerbreite oder der Stromanschluss. Der Deckenhinweis erscheint nur dort,
   wo er wirklich zaehlt, naemlich in oberen Etagen ab spuerbarem Gewicht.
   Im Keller und bei leichten Tresoren steht er gar nicht erst da.

   FACHLICH WICHTIG 3: Keine Lieferlaender und keine Preise im Tool. Sternchen
   und Sprungmarke in den Abschnitt Kosten und Liefergebiete desselben
   Ratgebers, dessen Ueberschrift die feste id lieferkosten traegt.
   ========================================================================== */
(function(){
  'use strict';
  var BT = window.BTModul = window.BTModul || { reg: {} };

  var L = {
    daten:'/collections/datentresor', feuer:'/collections/feuerschutztresor',
    zahlen:'/collections/tresor-mit-zahlenschloss', revision:'/collections/tresor-mit-zahlenschloss',
    rfid:'/collections/tresore', doppelbart:'/collections/tresore',
    ema:'/collections/tresore?filter.tag=opt-ema',
    waffe0:'/collections/waffenschrank', waffe1:'/collections/waffenschrank',
    tresore:'/collections/tresore', lieferung:'/blogs/ratgeber/lieferung-und-montage',
    beratung:'/pages/beratung-buchen', finder:'/pages/tresorfinder',
    grad0:'/collections/tresor-widerstandsgrad-0-en1143-1',
    grad1:'/collections/tresor-widerstandsgrad-1-en1143-1',
    grad2:'/collections/tresor-widerstandsgrad-2-en1143-1',
    grad3:'/collections/tresor-widerstandsgrad-3-en1143-1',
    grad4:'/collections/tresor-widerstandsgrad-4-en1143-1',
    grad5:'/collections/tresor-widerstandsgrad-5-en1143-1',
    grad6:'/collections/tresor-widerstandsgrad-6-en1143-1'
  };

  var A = {
    doppelbart:'/blogs/ratgeber/doppelbartschloss',
    zahlen:'/blogs/ratgeber/elektronisches-zahlenschloss',
    kaba:'/blogs/ratgeber/kaba-mauer-schloss',
    rfid:'/blogs/ratgeber/rfid-schloss',
    finger:'/blogs/ratgeber/fingerabdruck-schloss',
    schloesser:'/blogs/ratgeber/tresor-schloesser'
  };

  /* Die Pfade oben bleiben der Rueckfall. Was in den Theme-Einstellungen unter
     BT Minitools gepflegt ist, ueberschreibt sie einzeln — siehe
     snippets/bt-minitools-ziele.liquid. Ohne gepflegte Werte aendert sich
     nichts. Aendert sich ein Handle im Shop, wird er dort nachgezogen, ohne
     dass jemand diese Datei anfassen muss. (19.08.2026) */
  (function ueberschreiben(){
    var el = document.querySelector('[data-bt-minitools-ziele]');
    if (!el) return;
    var cfg;
    try { cfg = JSON.parse(el.textContent || '{}'); } catch (e) { return; }
    function misch(ziel, quelle){
      if (!quelle) return;
      for (var k in quelle) {
        if (Object.prototype.hasOwnProperty.call(quelle, k) && quelle[k]) ziel[k] = quelle[k];
      }
    }
    misch(L, cfg.ziele);
    misch(A, cfg.artikel);
  })();

  /* Mehrsprachigkeit (30.09.2026): Alle sichtbaren Texte laufen ueber btT
     (Woerterbuch aus snippets/bt-i18n-js.liquid, Schluessel bt.js.bt_minitools.*).
     Fehlt das Woerterbuch, bleibt es beim deutschen Originaltext. */
  var btT = window.btT || function(k, fb, vars){
    if(vars){ for(var p in vars){ fb = fb.split('{' + p + '}').join(vars[p]); } }
    return fb;
  };

  /* Interne Pfade bekommen das Sprachpraefix (z. B. /fr/), damit Besucher in
     ihrer Sprache bleiben. Auf Deutsch ist root '/', dann aendert sich nichts. */
  function lurl(h){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if(!h || root === '/' || h.charAt(0) !== '/' || h.charAt(1) === '/' || h.indexOf(root) === 0) return h;
    return root + h.slice(1);
  }

  function cta(l, h){ return '<a class="bt-btn" href="' + lurl(h) + '">' + l + '</a>'; }
  function cta2(l, h){ return '<a class="bt-btn bt-btn--ghost" href="' + lurl(h) + '">' + l + '</a>'; }
  function fmt(v){ return v.toLocaleString(document.documentElement.lang || 'de'); }

  function liste(arr){
    if(!arr.length) return '';
    if(arr.length === 1) return arr[0];
    return btT('bt_minitools.list_and', '{rest} und {last}', {rest: arr.slice(0, -1).join(', '), last: arr[arr.length - 1]});
  }

  function box(term, note, extra, ctas){
    var h = '<div class="bt-calc__reyebrow">' + btT('bt_minitools.your_recommendation', 'Ihre Empfehlung') + '</div>'
      + '<div class="bt-calc__grade">' + term + '</div>'
      + '<div class="bt-calc__note">' + note + '</div>';
    (extra || []).forEach(function(x){ if(x) h += '<div class="bt-calc__note">' + x + '</div>'; });
    if(ctas !== false){
      h += '<div class="bt-minitool__ctas">' + (ctas || (cta(btT('bt_minitools.cta_matching_safes', 'Passende Tresore ansehen'), L.tresore) + cta2(btT('bt_minitools.cta_start_finder', 'Tresorfinder starten'), L.finder))) + '</div>';
    }
    return h;
  }

  function head(eyebrow, title, intro){
    return '<div class="bt-calc__head"><div class="bt-eyebrow">' + eyebrow + '</div>'
      + '<h2>' + title + '</h2>' + (intro ? '<p>' + intro + '</p>' : '') + '</div>';
  }

  function qBlock(label, name, opts, multi, hint){
    var h = '<div class="bt-calc__q" data-q="' + name + '"><div class="bt-calc__qlabel">' + label
      + (hint ? ' <span class="bt-calc__qhint">' + hint + '</span>' : '') + '</div><div class="bt-calc__opts">';
    opts.forEach(function(o, i){
      var on = (!multi && i === 0);
      h += '<button type="button" class="bt-calc__opt' + (on ? ' is-active' : '') + '" data-v="' + o[0] + '" aria-pressed="' + (on ? 'true' : 'false') + '">'
        + o[1] + (o[2] ? '<small>' + o[2] + '</small>' : '') + '</button>';
    });
    return h + '</div></div>';
  }

  function wire(root, tool, state, multiFields, render){
    root.querySelectorAll('[data-q]').forEach(function(group){
      var name = group.getAttribute('data-q');
      var multi = multiFields.indexOf(name) > -1;
      group.querySelectorAll('.bt-calc__opt').forEach(function(b){
        b.addEventListener('click', function(){
          var v = b.getAttribute('data-v');
          if(multi){
            state[name] = state[name] || {};
            state[name][v] = !state[name][v];
            b.classList.toggle('is-active', !!state[name][v]);
            b.setAttribute('aria-pressed', state[name][v] ? 'true' : 'false');
          } else {
            state[name] = v;
            group.querySelectorAll('.bt-calc__opt').forEach(function(y){
              y.classList.toggle('is-active', y === b);
              y.setAttribute('aria-pressed', y === b ? 'true' : 'false');
            });
          }
          if(BT.track) BT.track('answered', tool, {frage:name, antwort:v});
          render();
        });
      });
    });
  }

  function mount(slot, tool, kopf, html, state, multiFields, compute){
    slot.innerHTML = '<div class="bt-calc" data-bt-calc>' + kopf + html
      + '<div class="bt-calc__result bt-calc__result--live" data-bt-result aria-live="polite"></div></div>';
    var root = slot.querySelector('[data-bt-calc]');
    var out  = root.querySelector('[data-bt-result]');
    function render(){
      var r = compute(state, root);
      out.innerHTML = r.html;
      if(r.ergebnis && BT.track) BT.track('completed', tool, {ergebnis:r.ergebnis});
    }
    wire(root, tool, state, multiFields, render);
    render();
  }

  /* ================= Widerstandsgrade, gemeinsame Datenbasis =================
     pm / gm = Obergrenze der Versicherungssumme privat / gewerblich.
     Referenztabelle freigegeben 11.08.2026.
     Mehrsprachigkeit (30.09.2026): Die Summen sind fachlich in EUR definiert
     (Versicherer-/VdS-Empfehlung), das Euro-Zeichen bleibt deshalb auch im
     CH-Markt stehen. Nur das Zahlenformat folgt der Sprache. */
  function bis(v){ return btT('bt_minitools.sum_up_to', 'bis {betrag} €', {betrag: fmt(v)}); }
  var G = [
    {n:'0',   c:'#5E73AC', p:bis(40000),   g:bis(10000),   pm:40000,  gm:10000,  w:14,  u:'grad0', t:btT('bt_minitools.grade0_desc', 'Einstiegsschutz nach EN 1143-1 für den Hausgebrauch.')},
    {n:'I',   c:'#4C63A0', p:bis(65000),   g:bis(20000),   pm:65000,  gm:20000,  w:28,  u:'grad1', t:btT('bt_minitools.grade1_desc', 'Solider Schutz für Zuhause, Praxis und kleines Büro.')},
    {n:'II',  c:'#3B5192', p:bis(100000),  g:bis(50000),   pm:100000, gm:50000,  w:42,  u:'grad2', t:btT('bt_minitools.grade2_desc', 'Erhöhter Schutz für höhere private Werte und Gewerbe.')},
    {n:'III', c:'#2B4082', p:bis(200000),  g:bis(100000),  pm:200000, gm:100000, w:57,  u:'grad3', t:btT('bt_minitools.grade3_desc', 'Für Gewerbe und höhere Werte, häufig von Versicherern gefordert.')},
    {n:'IV',  c:'#1B2F6E', p:bis(400000),  g:bis(150000),  pm:400000, gm:150000, w:71,  u:'grad4', t:btT('bt_minitools.grade4_desc', 'Hoher Schutz für sehr hohe Werte in Gewerbe und Handel.')},
    {n:'V',   c:'#132657', p:btT('bt_minitools.sum_over', 'über {betrag} €', {betrag: fmt(400000)}), g:bis(250000),  pm:Infinity, gm:250000, w:85, u:'grad5', t:btT('bt_minitools.grade5_desc', 'Hochsicherheit für Banken, Juweliere und Sammler.')},
    {n:'VI',  c:'#0B1D5E', p:btT('bt_minitools.sum_individual', 'individuelle Absprache'), g:bis(375000), pm:Infinity, gm:375000, w:100, u:'grad6', t:btT('bt_minitools.grade6_desc', 'Höchste Serienstufe. Die private Summe stimmen Sie direkt mit Ihrem Versicherer ab.')}
  ];

  var INHALT = [
    {k:'bargeld', l:btT('bt_minitools.content_cash', 'Bargeld'),
     hint:btT('bt_minitools.hint_cash_html', '<b>Bargeld wird oft separat begrenzt.</b> Viele Versicherer setzen für Bargeld eine eigene, niedrigere Summe an als für sonstige Wertsachen. Den konkreten Betrag vorab mit Ihrem Versicherer klären.')},
    {k:'schmuck', l:btT('bt_minitools.content_jewellery', 'Schmuck und Uhren')},
    {k:'dokumente', l:btT('bt_minitools.content_documents', 'Dokumente'),
     hint:btT('bt_minitools.hint_documents_html', '<b>Zusätzlich Feuerschutz prüfen.</b> Brandschutz ist eine eigene Prüfung nach <code>EN 15659</code> oder <code>EN 1047-1</code>. Ein hoher Widerstandsgrad allein schützt nicht vor Feuer.')},
    {k:'daten', l:btT('bt_minitools.content_data', 'Datenträger'),
     hint:btT('bt_minitools.hint_data_html', '<b>Datenträger brauchen eine eigene Feuerschutzklasse.</b> Die Norm erlaubt im Tresorinneren einen Temperaturanstieg von 150 Grad für Papier, aber nur 30 Grad für Datenträger. Dafür gibt es die DIS-Klassen nach <code>EN 1047-1</code>.')},
    {k:'waffen', l:btT('bt_minitools.content_weapons', 'Waffen und Munition'), min:1,
     hint:btT('bt_minitools.hint_weapons_html', '<b>Vorgabe aus dem Waffengesetz.</b> Nach <code>§ 36 WaffG</code> gilt für Waffen mindestens Grad I, unabhängig vom Wert.')},
    {k:'btm', l:btT('bt_minitools.content_narcotics', 'Betäubungsmittel'), min:1,
     hint:btT('bt_minitools.hint_narcotics_html', '<b>Vorgabe aus dem Betäubungsmittelgesetz.</b> Nach <code>§ 15 BtMG</code> ist mindestens Grad I nötig, und der Tresor muss unter 1.000 kg am Verwendungsort verankert werden.')},
    {k:'edelmetall', l:btT('bt_minitools.content_metals', 'Edelmetalle und Münzen')}
  ];

  /* ===================== Grad-Auswahl zum Durchklicken ===================== */
  BT.reg['gradpicker'] = function(slot, uid){
    var r='', ch='', pa='';
    G.forEach(function(x, i){
      var id = uid + '-' + i;
      r  += '<input class="bt-gradepick__radios" type="radio" name="' + uid + '" id="' + id + '"' + (i===0?' checked':'') + '>';
      ch += '<label class="bt-gradepick__chip" for="' + id + '"><span class="bt-gradepick__dot" style="background:' + x.c + ';"></span>' + btT('bt_minitools.grade', 'Grad {n}', {n: x.n}) + '</label>';
      pa += '<div class="bt-gradepick__panel bt-gradepick__panel--' + i + '">'
          + '<div class="bt-gradepick__head"><span class="bt-gradepick__badge" style="background:' + x.c + ';">' + btT('bt_minitools.grade', 'Grad {n}', {n: x.n}) + '</span>'
          + '<span class="bt-gradepick__sum">' + btT('bt_minitools.sum_private', '{summe} privat', {summe: x.p}) + '</span></div>'
          + '<div class="bt-gradepick__desc">' + x.t + '</div>'
          + '<div class="bt-gradepick__meter"><span style="width:' + x.w + '%;background:' + x.c + ';"></span></div>'
          + '<div class="bt-gradepick__scale"><span>' + btT('bt_minitools.scale_low', 'leichter Schutz') + '</span><span>' + btT('bt_minitools.scale_high', 'höchster Schutz') + '</span></div></div>';
    });
    slot.innerHTML = '<div class="bt-calc">'
      + head(btT('bt_minitools.gp_eyebrow', 'Zum Durchklicken'), btT('bt_minitools.gp_title', 'Die Widerstandsgrade im Überblick'), btT('bt_minitools.gp_intro', 'Tippen Sie einen Grad an, um zu sehen, wofür er gebaut ist.'))
      + '<div class="bt-gradepick">' + r
      + '<div class="bt-gradepick__chips">' + ch + '</div>'
      + '<div class="bt-gradepick__body">' + pa + '</div></div></div>';
  };

  /* ===================== Sicherheitsstufen-Rechner ===================== */
  BT.reg['rechner-sicherheitsstufe'] = function(slot, uid){
    var opts = INHALT.map(function(o, i){
      return '<button type="button" class="bt-calc__opt' + (i===0?' is-active':'') + '" data-cont="' + o.k + '" aria-pressed="' + (i===0?'true':'false') + '">' + o.l + '</button>';
    }).join('');

    slot.innerHTML = '<div class="bt-calc" data-bt-calc>'
      + head(btT('bt_minitools.rs_eyebrow', 'In 3 Fragen zum Grad'), btT('bt_minitools.rs_title', 'Welchen Widerstandsgrad brauche ich?'),
             btT('bt_minitools.rs_intro', 'Der Rechner geht von der Versicherungssumme aus. Bei Waffen und Betäubungsmitteln greifen gesetzliche Mindestgrade automatisch.'))
      + '<div class="bt-calc__q"><div class="bt-calc__qlabel">' + btT('bt_minitools.rs_q1', '1 · Nutzung') + '</div>'
      + '<div class="bt-calc__opts" data-bt-use>'
      + '<button type="button" class="bt-calc__opt is-active" data-use="privat" aria-pressed="true">' + btT('bt_minitools.use_private', 'Privat') + '</button>'
      + '<button type="button" class="bt-calc__opt" data-use="gewerblich" aria-pressed="false">' + btT('bt_minitools.use_business', 'Gewerblich') + '</button>'
      + '</div></div>'
      + '<div class="bt-calc__q"><div class="bt-calc__qlabel">' + btT('bt_minitools.rs_q2', '2 · Wert der Verwahrung') + ' <span class="bt-calc__qhint">' + btT('bt_minitools.rs_q2_hint', '(Versicherungssumme)') + '</span></div>'
      + '<div class="bt-calc__opts" data-bt-sum></div>'
      + '<div class="bt-calc__custom"><label for="' + uid + '-eigen">' + btT('bt_minitools.rs_custom_label', 'oder eigener Betrag') + '</label>'
      + '<span class="bt-calc__inputwrap"><input id="' + uid + '-eigen" type="text" inputmode="numeric" autocomplete="off" placeholder="' + fmt(85000) + '" data-bt-eigen><span>€</span></span>'
      + '<button type="button" class="bt-calc__reset" data-bt-reset hidden>' + btT('bt_minitools.rs_reset', 'zurück zur Auswahl') + '</button></div></div>'
      + '<div class="bt-calc__q"><div class="bt-calc__qlabel">' + btT('bt_minitools.rs_q3', '3 · Was verwahren Sie?') + ' <span class="bt-calc__qhint">' + btT('bt_minitools.hint_multi', '(Mehrfachauswahl)') + '</span></div>'
      + '<div class="bt-calc__opts" data-bt-cont>' + opts + '</div></div>'
      + '<div class="bt-calc__result bt-calc__result--live" data-bt-result aria-live="polite"></div></div>';

    var root = slot.querySelector('[data-bt-calc]');
    var sums = root.querySelector('[data-bt-sum]');
    var out = root.querySelector('[data-bt-result]');
    var eigen = root.querySelector('[data-bt-eigen]');
    var reset = root.querySelector('[data-bt-reset]');
    var st = { use:'privat', idx:0, betrag:null, cont:{ bargeld:true } };

    function maxKey(){ return st.use === 'privat' ? 'pm' : 'gm'; }

    function renderSums(){
      sums.innerHTML = '';
      G.forEach(function(x, i){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'bt-calc__opt' + (st.betrag === null && i === st.idx ? ' is-active' : '');
        b.textContent = (st.use === 'privat' ? x.p : x.g);
        b.setAttribute('aria-pressed', st.betrag === null && i === st.idx ? 'true' : 'false');
        b.addEventListener('click', function(){
          st.idx = i; st.betrag = null; eigen.value = '';
          reset.hidden = true; renderSums(); calc();
        });
        sums.appendChild(b);
      });
    }

    function gradVonBetrag(v){
      var k = maxKey();
      for(var i = 0; i < G.length; i++){ if(v <= G[i][k]) return i; }
      return G.length - 1;
    }

    function calc(){
      var i = st.betrag !== null ? gradVonBetrag(st.betrag) : st.idx;
      var notes = [];
      INHALT.forEach(function(o){ if(st.cont[o.k] && o.min && i < o.min) i = o.min; });
      INHALT.forEach(function(o){ if(st.cont[o.k] && o.hint) notes.push('<div class="bt-calc__note">' + o.hint + '</div>'); });

      var x = G[i];
      var basis = st.betrag !== null ? btT('bt_minitools.sum_amount', '{betrag} €', {betrag: fmt(st.betrag)}) : (st.use === 'privat' ? x.p : x.g);

      notes.push('<div class="bt-calc__note">' + btT('bt_minitools.rs_tip_alarm', 'Tipp: Mit Anschluss an Ihre Alarmanlage verdoppelt sich meist die versicherbare Summe.') + '</div>');
      if(i >= 5) notes.push('<div class="bt-calc__note">' + btT('bt_minitools.rs_grade7', 'Sie brauchen noch mehr? Grad VII bauen wir auf Anfrage.') + '</div>');

      out.innerHTML = '<div class="bt-calc__reyebrow">' + btT('bt_minitools.your_recommendation', 'Ihre Empfehlung') + '</div>'
        + '<div class="bt-calc__grade">' + btT('bt_minitools.grade', 'Grad {n}', {n: x.n}) + '</div>'
        + '<div class="bt-calc__note">'
        + (st.use === 'privat'
          ? btT('bt_minitools.rs_result_private_html', 'Empfohlener Widerstandsgrad nach <code>EN 1143-1</code> für private Nutzung bei {basis}.', {basis: basis})
          : btT('bt_minitools.rs_result_business_html', 'Empfohlener Widerstandsgrad nach <code>EN 1143-1</code> für gewerbliche Nutzung bei {basis}.', {basis: basis}))
        + '</div>'
        + notes.join('')
        + '<div class="bt-minitool__ctas">' + cta(btT('bt_minitools.cta_matching_safes', 'Passende Tresore ansehen'), L[x.u] || L.tresore) + cta2(btT('bt_minitools.cta_advice', 'Beraten lassen'), L.beratung) + '</div>';

      if(BT.track) BT.track('completed', 'rechner-sicherheitsstufe', {ergebnis:'Grad ' + x.n});
    }

    root.querySelectorAll('[data-use]').forEach(function(b){
      b.addEventListener('click', function(){
        st.use = b.dataset.use;
        if(st.betrag === null) st.idx = 0;
        root.querySelectorAll('[data-use]').forEach(function(y){
          y.classList.toggle('is-active', y === b);
          y.setAttribute('aria-pressed', y === b ? 'true' : 'false');
        });
        renderSums(); calc();
      });
    });

    root.querySelectorAll('[data-cont]').forEach(function(b){
      b.addEventListener('click', function(){
        var k = b.dataset.cont;
        st.cont[k] = !st.cont[k];
        b.classList.toggle('is-active', !!st.cont[k]);
        b.setAttribute('aria-pressed', st.cont[k] ? 'true' : 'false');
        calc();
      });
    });

    eigen.addEventListener('input', function(){
      var digits = eigen.value.replace(/[^0-9]/g, '');
      if(!digits){ st.betrag = null; reset.hidden = true; eigen.value = ''; renderSums(); calc(); return; }
      st.betrag = parseInt(digits, 10);
      eigen.value = fmt(st.betrag);
      reset.hidden = false; renderSums(); calc();
    });
    reset.addEventListener('click', function(){
      st.betrag = null; eigen.value = ''; reset.hidden = true; renderSums(); calc();
    });

    renderSums(); calc();
  };

  /* ======================= Feuerschutzklasse ======================= */
  BT.reg['feuerschutzklasse'] = function(slot){
    var kopf = head(btT('bt_minitools.eyebrow_2q_class', 'In 2 Fragen zur Klasse'), btT('bt_minitools.fs_title', 'Welche Feuerschutzklasse brauche ich?'),
      btT('bt_minitools.fs_intro', 'Sie müssen die Normbezeichnungen dafür nicht kennen. Entscheidend sind nur zwei Dinge.'));
    var html =
      qBlock(btT('bt_minitools.fs_q1', '1 · Was soll einen Brand überstehen?'), 'inhalt', [
        ['papier', btT('bt_minitools.fs_paper', 'Papier'), btT('bt_minitools.fs_paper_sub', 'Urkunden, Verträge, Fotos, Bargeld')],
        ['daten', btT('bt_minitools.fs_data', 'Digitale Datenträger'), btT('bt_minitools.fs_data_sub', 'Festplatten, USB-Sticks, Speicherkarten')],
        ['beides', btT('bt_minitools.fs_both', 'Beides'), btT('bt_minitools.fs_both_sub', 'Papier und Datenträger')]
      ]) +
      qBlock(btT('bt_minitools.fs_q2', '2 · Wie schwer wäre der Verlust?'), 'verlust', [
        ['ersetzbar', btT('bt_minitools.fs_loss_replaceable', 'Ärgerlich, aber ersetzbar'), btT('bt_minitools.fs_loss_replaceable_sub', 'Kopien oder Backups existieren')],
        ['schwer', btT('bt_minitools.fs_loss_hard', 'Schwer ersetzbar'), btT('bt_minitools.fs_loss_hard_sub', 'Originale und Urkunden')],
        ['unersetzlich', btT('bt_minitools.fs_loss_irreplaceable', 'Unersetzlich'), btT('bt_minitools.fs_loss_irreplaceable_sub', 'einziges Exemplar, existenzwichtig')]
      ]);

    var feuerCta = btT('bt_minitools.cta_fire_safes', 'Feuerschutztresore ansehen');
    var finderCta = btT('bt_minitools.cta_start_finder', 'Tresorfinder starten');

    /* erg = deutscher Ergebniswert fuers Tracking, bleibt in allen Sprachen gleich. */
    mount(slot, 'feuerschutzklasse', kopf, html, {inhalt:'papier', verlust:'ersetzbar'}, [], function(s){
      var daten = s.inhalt !== 'papier';
      var term, note, erg, extra = [], ctas;
      if(daten){
        if(s.verlust === 'unersetzlich'){
          erg = '120 Minuten Feuerschutz für Datenträger';
          term = btT('bt_minitools.fs_term_data120', '120 Minuten Feuerschutz für Datenträger');
          note = btT('bt_minitools.fs_note_data120_html', 'Zwei volle Stunden Beflammung plus Nachhitze, geprüft nach <code>EN 1047-1</code>, Klasse <code>S 120 DIS</code>, inklusive Sturztest.');
        } else {
          erg = '60 Minuten Feuerschutz für Datenträger';
          term = btT('bt_minitools.fs_term_data60', '60 Minuten Feuerschutz für Datenträger');
          note = btT('bt_minitools.fs_note_data60_html', 'Geprüft nach <code>EN 1047-1</code>, Klasse <code>S 60 DIS</code>, inklusive Sturztest. Schützt automatisch auch Papier.');
        }
        extra.push(btT('bt_minitools.fs_why_data_html', '<b>Warum Datenträger eine eigene Klasse brauchen:</b> Die Norm begrenzt nicht die Außentemperatur, sondern den <b>Anstieg im Innenraum</b> gegenüber dem Start. Für Papier sind 150 Grad Anstieg zulässig, für Datenträger nur 30 Grad. Eine P-Klasse erfüllt diesen engeren Wert nicht, auch wenn sie länger geprüft ist.'));
        extra.push(btT('bt_minitools.fs_pro_data', 'Profi-Technik mit massiver Spezialisolierung, gebaut für Firmendaten, Kanzleien, Praxen und wertvolle private Archive.'));
        extra.push(btT('bt_minitools.fs_backup_alt', 'Existiert bereits ein Backup außer Haus, oder nutzen Sie einen feuerfesten Dokumentenkoffer für die Papiere? Dann reicht auch ein Standard-Feuerschutztresor, beide Wege stehen Ihnen gleichwertig unten offen.'));
        ctas = cta(btT('bt_minitools.cta_data_safes', 'Datentresore ansehen'), L.daten) + cta(feuerCta, L.feuer);
      } else if(s.verlust === 'ersetzbar'){
        erg = '30 Minuten Feuerschutz';
        term = btT('bt_minitools.fs_term30', '30 Minuten Feuerschutz');
        note = btT('bt_minitools.fs_note30_html', 'Genug Zeit für einen typischen Wohnungsbrand, die Feuerwehr braucht im Schnitt 15 bis 20 Minuten. Geprüfte Klasse <code>LFS 30 P</code>.');
        ctas = cta(feuerCta, L.feuer) + cta2(finderCta, L.finder);
      } else if(s.verlust === 'schwer'){
        erg = '60 Minuten Feuerschutz';
        term = btT('bt_minitools.fs_term60', '60 Minuten Feuerschutz');
        note = btT('bt_minitools.fs_note60_html', 'Ihre Originale überstehen einen ausgewachsenen Brand. Geprüft nach <code>EN 1047-1</code>, Klasse <code>S 60 P</code>, inklusive Sturztest.');
        ctas = cta(feuerCta, L.feuer) + cta2(finderCta, L.finder);
      } else {
        erg = '120 Minuten Feuerschutz';
        term = btT('bt_minitools.fs_term120', '120 Minuten Feuerschutz');
        note = btT('bt_minitools.fs_note120_html', 'Die höchste Stufe für Unersetzliches: zwei Stunden Beflammung bei 1.090 Grad plus Nachhitze-Messung. Klasse <code>S 120 P</code>.');
        ctas = cta(feuerCta, L.feuer) + cta2(finderCta, L.finder);
      }
      return {html: box(term, note, extra, ctas), ergebnis: erg};
    });
  };

  /* ============================ Schloss ============================ */
  BT.reg['schloss'] = function(slot){
    var kopf = head(btT('bt_minitools.lk_eyebrow', 'In 3 Fragen zum Schloss'), btT('bt_minitools.lk_title', 'Welches Schloss passt zu mir?'),
      btT('bt_minitools.lk_intro', 'Sagen Sie, wie Sie öffnen möchten und welche Funktionen Sie brauchen. Wir nennen Ihnen das kleinste Schloss, das alles davon kann.'));
    var html =
      qBlock(btT('bt_minitools.lk_q1', '1 · Womit möchten Sie am liebsten öffnen?'), 'oeffnung', [
        ['code', btT('bt_minitools.lk_code', 'Code eintippen'), btT('bt_minitools.lk_code_sub', 'kein Schlüssel nötig')],
        ['chip', btT('bt_minitools.lk_chip', 'Chip oder Karte vorhalten'), btT('bt_minitools.lk_chip_sub', 'der schnellste Zugriff')],
        ['schluessel', btT('bt_minitools.lk_key', 'Klassisch mit Schlüssel'), btT('bt_minitools.lk_key_sub', 'bewusst ohne Elektronik')]
      ]) +
      qBlock(btT('bt_minitools.lk_q2', '2 · Wie viele Personen sollen eigenen Zugang haben?'), 'nutzer', [
        ['wenige', btT('bt_minitools.lk_users_few', 'Ich, oder ein kleiner fester Kreis'), ''],
        ['mehr9', btT('bt_minitools.lk_users_many', 'Mehr als 9'), btT('bt_minitools.lk_users_many_sub', 'Personal, Schichtbetrieb')]
      ]) +
      qBlock(btT('bt_minitools.lk_q3', '3 · Welche Funktionen brauchen Sie?'), 'fx', [
        ['revision', btT('bt_minitools.lk_fx_revision', 'Notschlüssel als Rückversicherung'), btT('bt_minitools.lk_fx_revision_sub', 'öffnet auch bei leerer Batterie oder vergessenem Code')],
        ['protokoll', btT('bt_minitools.lk_fx_log', 'Sehen, wer wann geöffnet hat'), ''],
        ['vieraugen', btT('bt_minitools.lk_fx_dual', 'Nur zu zweit zu öffnen'), btT('bt_minitools.lk_fx_dual_sub', 'Vieraugen-Prinzip')],
        ['verzoegerung', btT('bt_minitools.lk_fx_delay', 'Öffnet erst nach Wartezeit'), btT('bt_minitools.lk_fx_delay_sub', 'Überfallschutz')],
        ['ema', btT('bt_minitools.lk_fx_ema', 'Anschluss an die Alarmanlage'), btT('bt_minitools.lk_fx_ema_sub', 'nur mit VdS-Alarmanlage und der EMA-Komponente')],
        ['stillalarm', btT('bt_minitools.lk_fx_silent', 'Stiller Alarm'), btT('bt_minitools.lk_fx_silent_sub', 'setzt den Anschluss an die Alarmanlage voraus')]
      ], true, btT('bt_minitools.hint_all_apply', '(alles antippen, was zutrifft)'));

    var STD = [
      {k:'nutzer',       t:btT('bt_minitools.lk_std_users', 'bis zu 88 Benutzercodes')},
      {k:'vieraugen',    t:btT('bt_minitools.lk_std_dual', 'das Vieraugen-Prinzip')},
      {k:'verzoegerung', t:btT('bt_minitools.lk_std_delay', 'die Öffnungsverzögerung')},
      {k:'protokoll',    t:btT('bt_minitools.lk_std_log', 'ein Protokoll der letzten 960 Ereignisse')},
      {k:'revision',     t:btT('bt_minitools.lk_std_override', 'die verdeckte mechanische Notöffnung')}
    ];
    var EMAF = [
      {k:'ema',        t:btT('bt_minitools.lk_ema_connect', 'den Anschluss an Ihre Alarmanlage')},
      {k:'stillalarm', t:btT('bt_minitools.lk_ema_silent', 'den stillen Alarm')},
      {k:'fernsperre', t:btT('bt_minitools.lk_ema_remote', 'die Fernsperre, solange die Anlage scharf geschaltet ist')}
    ];

    function wege(shopLabel, shopZiel, artikelZiel){
      return cta(shopLabel, shopZiel)
        + cta2(btT('bt_minitools.cta_more_info', 'Mehr Informationen'), artikelZiel)
        + cta2(btT('bt_minitools.cta_advice', 'Beraten lassen'), L.beratung);
    }

    mount(slot, 'schloss', kopf, html, {oeffnung:'code', nutzer:'wenige', fx:{}}, ['fx'], function(s){
      var fx = s.fx || {};
      var an = function(k){ return k === 'nutzer' ? s.nutzer === 'mehr9' : !!fx[k]; };
      var emaWunsch = !!(fx.ema || fx.stillalarm);
      var stdWunsch = an('nutzer') || an('vieraugen') || an('verzoegerung');

      if(emaWunsch || stdWunsch){
        var gewaehltStd = [], restStd = [], gewaehltEma = [], restEma = [];
        STD.forEach(function(f){ (an(f.k) ? gewaehltStd : restStd).push(f.t); });
        EMAF.forEach(function(f){ (an(f.k) ? gewaehltEma : restEma).push(f.t); });

        var gewaehlt = gewaehltStd.concat(gewaehltEma);
        var extra = [];

        if(restStd.length){
          extra.push(btT('bt_minitools.lk_also_standard_html', '<b>Serienmäßig ebenfalls dabei:</b> {liste}.', {liste: liste(restStd)}));
        }

        if(emaWunsch){
          var e = btT('bt_minitools.lk_ema_tech_html', '<b>Dafür kommt Technik dazu:</b> {liste} funktioniert nur mit einer VdS-Alarmanlage und der EMA-Komponente im Tresor, also Sensorik und Meldeeinrichtung, keine komplette Hausanlage.', {liste: liste(gewaehltEma)});
          if(restEma.length) e += ' ' + btT('bt_minitools.lk_ema_more', 'Ist sie einmal verbaut, steht Ihnen zusätzlich {liste} offen.', {liste: liste(restEma)});
          e += ' ' + btT('bt_minitools.lk_ema_side', 'Nebeneffekt: Das verdoppelt bei vielen Versicherern die versicherbare Summe.');
          extra.push(e);
          if(fx.stillalarm && !fx.ema){
            extra.push(btT('bt_minitools.lk_silent_note_html', '<b>Hinweis zum stillen Alarm:</b> Er ist keine eigenständige Funktion, sondern läuft über denselben Anschluss an die Alarmanlage. Sie brauchen also beides zusammen.'));
          }
        }

        return {html: box('Kaba Mauer Combi B 90',
          btT('bt_minitools.lk_kaba_note', 'Sie brauchen {liste}. Genau dafür ist unser Spitzenschloss gebaut, VdS-zertifiziert und ab Widerstandsgrad 4 ohnehin die richtige Wahl.', {liste: liste(gewaehlt)}),
          extra, wege(btT('bt_minitools.lk_cta_kaba', 'Wertschutzschränke mit Kaba Mauer ansehen'), L.ema, A.kaba)), ergebnis:'Kaba Mauer'};
      }

      if(s.oeffnung === 'schluessel'){
        if(fx.revision || fx.protokoll){
          return {html: box(btT('bt_minitools.lk_term_revision', 'Zahlenschloss mit Notschlüssel (Revision)'),
            btT('bt_minitools.lk_rev_key_note', 'Die Brücke aus beiden Welten: im Alltag der Code, und Ihr Schlüssel bleibt als Rückversicherung. Die gewünschten Funktionen gibt es nur elektronisch.'),
            [fx.protokoll ? btT('bt_minitools.lk_log32', 'Das Schloss merkt sich die letzten 32 Öffnungen.') : btT('bt_minitools.lk_rev_emergency', 'Der Notschlüssel öffnet auch bei leerer Batterie oder vergessenem Code.')],
            wege(btT('bt_minitools.lk_cta_revision', 'Tresore mit Revisionsschloss ansehen'), L.revision, A.zahlen)), ergebnis:'Revision'};
        }
        return {html: box(btT('bt_minitools.lk_term_doublebit', 'Doppelbartschloss'),
          btT('bt_minitools.lk_doublebit_note', 'Kein Strom, keine Batterie, unverwüstlich, übersteht sogar Brände. Der bewährte Klassiker, serienmäßig in vielen Modellen.'),
          [btT('bt_minitools.lk_doublebit_honest', 'Ganz ehrlich dazu: Der lange Schlüssel braucht selbst ein sicheres Versteck, denn danach sucht ein Einbrecher zuerst.')],
          wege(btT('bt_minitools.lk_cta_doublebit', 'Tresore mit Doppelbartschloss ansehen'), L.doppelbart, A.doppelbart)), ergebnis:'Doppelbart'};
      }

      if(s.oeffnung === 'chip'){
        return {html: box(btT('bt_minitools.lk_term_rfid', 'RFID-Schloss'),
          btT('bt_minitools.lk_rfid_note', 'Chip vor die Tastatur halten, auf, zu. Bis zu 20 Chips, die Sie ausgeben und wieder einziehen können, ohne dass je ein Code die Runde macht.'),
          [btT('bt_minitools.lk_rfid_lost', 'Verlorene Chips sperren Sie einfach, ohne das Schloss zu tauschen.'),
           fx.revision ? btT('bt_minitools.lk_rfid_usb', 'Für die Rückversicherung: Bei Defekt hilft die Notbestromung per USB, alternativ beraten wir zur Revisions-Variante.') : ''],
          wege(btT('bt_minitools.lk_cta_rfid', 'Tresore mit RFID ansehen'), L.rfid, A.rfid)), ergebnis:'RFID'};
      }

      if(fx.revision){
        return {html: box(btT('bt_minitools.lk_term_revision', 'Zahlenschloss mit Notschlüssel (Revision)'),
          btT('bt_minitools.lk_rev_code_note', 'Im Alltag öffnen Sie per Code, und für den seltenen Fall eines Elektronik-Defekts oder vergessenen Codes liegt der Notschlüssel bereit.'),
          [fx.protokoll ? btT('bt_minitools.lk_log32', 'Das Schloss merkt sich die letzten 32 Öffnungen.') : btT('bt_minitools.lk_police_code', 'Auch die Polizei empfiehlt den Verschluss per Code.')],
          wege(btT('bt_minitools.lk_cta_revision', 'Tresore mit Revisionsschloss ansehen'), L.revision, A.zahlen)), ergebnis:'Revision'};
      }

      return {html: box(btT('bt_minitools.lk_term_electronic', 'Elektronisches Zahlenschloss'),
        btT('bt_minitools.lk_electronic_note', 'Kein Schlüssel, den Sie verstecken müssten, Ihr Code ist jederzeit änderbar. Auch die Polizei empfiehlt diesen Verschluss.'),
        [fx.protokoll ? btT('bt_minitools.lk_log32_super', 'Das Schloss merkt sich die letzten 32 Öffnungen, mit Supercode für den Notfall.') : btT('bt_minitools.lk_six_digits', 'Sechs Ziffern, drei Sekunden, offen. Mit Supercode für den Notfall.')],
        wege(btT('bt_minitools.lk_cta_code', 'Tresore mit Zahlenschloss ansehen'), L.zahlen, A.zahlen)), ergebnis:'Zahlenschloss'};
    });
  };

  /* ========================= Waffenklasse ========================= */
  BT.reg['waffenklasse'] = function(slot){
    var kopf = head(btT('bt_minitools.eyebrow_2q_class', 'In 2 Fragen zur Klasse'), btT('bt_minitools.wk_title', 'Klasse 0 oder Klasse 1?'),
      btT('bt_minitools.wk_intro', 'Für Jäger entscheidet nicht die Stückzahl, sondern wie viel Reserve Sie möchten. Beide Wege sind gesetzeskonform.'));
    var html =
      qBlock(btT('bt_minitools.wk_q1', '1 · Was beschreibt Sie am besten?'), 'profil', [
        ['jaeger', btT('bt_minitools.wk_hunter', 'Jäger'), btT('bt_minitools.wk_hunter_sub', 'Langwaffen, höchstens 2 Kurzwaffen')],
        ['sport', btT('bt_minitools.wk_sport', 'Sportschütze oder Sammler'), btT('bt_minitools.wk_sport_sub', 'mehrere Kurzwaffen')]
      ]) +
      qBlock(btT('bt_minitools.wk_q2_mindset', '2 · Wie kaufen Sie am liebsten?'), 'mindset', [
        ['sicher', btT('bt_minitools.wk_safe', 'Auf Nummer sicher'), btT('bt_minitools.wk_safe_sub', 'Reserve für alles, was noch kommt')],
        ['guenstig', btT('bt_minitools.wk_budget', 'Gesetzeskonform zum besten Preis'), '']
      ]) +
      qBlock(btT('bt_minitools.wk_q2_count', '2 · Wie viele Kurzwaffen, heute und absehbar?'), 'anzahl', [
        ['bleibt5', btT('bt_minitools.wk_count_stays5', 'Bis 5, und das bleibt so'), ''],
        ['wachsend', btT('bt_minitools.wk_count_growing', 'Bis 5, aber es werden mehr'), ''],
        ['mehr5', btT('bt_minitools.wk_count_more5', 'Mehr als 5'), '']
      ]);

    var kl1 = btT('bt_minitools.wk_term_class1', 'Klasse 1');
    var kl0 = btT('bt_minitools.wk_term_class0', 'Klasse 0 (N/0)');
    var cta1 = btT('bt_minitools.wk_cta_class1', 'Waffenschränke Klasse 1 ansehen');
    var cta0 = btT('bt_minitools.wk_cta_class0', 'Waffenschränke Klasse 0 ansehen');
    var beraten = btT('bt_minitools.cta_advice', 'Beraten lassen');

    mount(slot, 'waffenklasse', kopf, html, {profil:'jaeger', mindset:'sicher', anzahl:'bleibt5'}, [], function(s, root){
      var qs = root.querySelectorAll('[data-q]');
      if(qs[1]) qs[1].style.display = s.profil === 'jaeger' ? '' : 'none';
      if(qs[2]) qs[2].style.display = s.profil === 'sport' ? '' : 'none';
      var muni = btT('bt_minitools.wk_ammo', 'Munition darf mit in den Schrank, ein separates Fach schafft Ordnung.');
      if(s.profil === 'jaeger'){
        if(s.mindset === 'sicher'){
          return {html: box(kl1,
            btT('bt_minitools.wk_hunter_safe_note', 'Die Wahl auf Nummer sicher: unbegrenzt Kurzwaffen, die höhere Versicherungssumme, und egal was der Gesetzgeber künftig ändert, Ihr Schrank ist schon darüber. Viele unserer Jäger entscheiden sich genau deshalb für Klasse 1.'),
            [muni, btT('bt_minitools.wk_class0_alt', 'Klasse 0 wäre heute ebenfalls zulässig, der Aufpreis kauft die Gelassenheit für Jahrzehnte.')],
            cta(cta1, L.waffe1) + cta2(beraten, L.beratung)), ergebnis:'Klasse 1'};
        }
        return {html: box(kl0,
          btT('bt_minitools.wk_hunter_budget_note_html', 'Erfüllt <code>§ 36 WaffG</code> heute vollständig: unbegrenzt Langwaffen, und Ihre bis zu 2 Kurzwaffen sind ausdrücklich abgedeckt, zulässig sind bis zu 5. Geprüft nach <code>EN 1143-1</code>, zum besten Preis.'),
          [muni, btT('bt_minitools.wk_growth', 'Falls die Sammlung doch wächst: bis 5 Kurzwaffen bleibt alles zulässig, erst darüber braucht es Klasse 1.')],
          cta(cta0, L.waffe0) + cta2(beraten, L.beratung)), ergebnis:'Klasse 0'};
      }
      if(s.anzahl === 'bleibt5'){
        return {html: box(kl0,
          btT('bt_minitools.wk_sport_class0_note_html', 'Für Langwaffen und bis zu 5 Kurzwaffen erfüllt Klasse 0 das Waffengesetz vollständig, geprüft nach <code>EN 1143-1</code>.'),
          [muni, btT('bt_minitools.wk_edge', 'Randfall: Wiegt der Schrank über 200 kg, sind in Klasse 0 sogar bis zu 10 Kurzwaffen zulässig.')],
          cta(cta0, L.waffe0) + cta2(beraten, L.beratung)), ergebnis:'Klasse 0'};
      }
      return {html: box(kl1,
        s.anzahl === 'mehr5'
          ? btT('bt_minitools.wk_more5_note_html', 'Ab der sechsten Kurzwaffe schreibt <code>§ 36 WaffG</code> mindestens Klasse 1 vor. Damit sind Sie unbegrenzt frei.')
          : btT('bt_minitools.wk_growing_note', 'Ihr Bestand würde heute in Klasse 0 passen. Weil ein Waffenschrank für Jahrzehnte gekauft wird und Ihre Sammlung wächst, ist Klasse 1 die Wahl ohne späteren Zweitkauf.'),
        [muni],
        cta(cta1, L.waffe1) + cta2(beraten, L.beratung)), ergebnis:'Klasse 1'};
    });
  };

  /* ========================== Platz-Check ==========================
     DREI Fragen: Raum, Etage, Gewicht. Raum und Etage sind getrennt, weil sich
     das eine nicht aus dem anderen ableiten laesst. Ein Buero kann im Keller
     wie im Dachgeschoss liegen.

     TON: Die Etagentexte sind Fachwissen, keine Warnungen. Der Deckenhinweis
     erscheint ausschliesslich in oberen Etagen ab 100 kg. Im Keller, im
     Erdgeschoss und bei leichten Tresoren steht er gar nicht erst da, weil er
     dort nur Sorgen macht, ohne etwas zu klaeren. */
  BT.reg['platz-check'] = function(slot){
    var kopf = head(btT('bt_minitools.pc_eyebrow', 'In 3 Fragen zum Platz'), btT('bt_minitools.pc_title', 'Ist Ihr Wunschplatz eine gute Wahl?'),
      btT('bt_minitools.pc_intro', 'Raum, Etage und ungefähres Gewicht. Sie bekommen ein Urteil zum Raum, die passende Verankerungs-Anleitung und die Punkte, die Sie vorab klären sollten.'));

    var html =
      qBlock(btT('bt_minitools.pc_q1', '1 · In welchem Raum soll der Tresor stehen?'), 'raum', [
        ['abstell', btT('bt_minitools.pc_room_storage', 'Abstellraum oder Hauswirtschaftsraum'), ''],
        ['flur', btT('bt_minitools.pc_room_hall', 'Flur oder Diele'), ''],
        ['buero', btT('bt_minitools.pc_room_office', 'Arbeitszimmer oder Büro'), ''],
        ['schlaf', btT('bt_minitools.pc_room_bedroom', 'Schlafzimmer'), ''],
        ['ankleide', btT('bt_minitools.pc_room_dressing', 'Ankleide oder begehbarer Schrank'), ''],
        ['wohn', btT('bt_minitools.pc_room_living', 'Wohnzimmer'), ''],
        ['kueche', btT('bt_minitools.pc_room_kitchen', 'Küche'), ''],
        ['garage', btT('bt_minitools.pc_room_garage', 'Garage oder Nebengebäude'), '']
      ]) +
      qBlock(btT('bt_minitools.pc_q2', '2 · In welcher Etage?'), 'etage', [
        ['ebenerdig', btT('bt_minitools.pc_floor_ground', 'Ebenerdig'), btT('bt_minitools.pc_floor_ground_sub', 'Erdgeschoss')],
        ['keller', btT('bt_minitools.pc_floor_basement', 'Keller oder Souterrain'), ''],
        ['oben', btT('bt_minitools.pc_floor_upper', 'Obere Etage'), ''],
        ['dach', btT('bt_minitools.pc_floor_attic', 'Dachgeschoss'), '']
      ]) +
      qBlock(btT('bt_minitools.pc_q3', '3 · Wie schwer wird der Tresor ungefähr?'), 'gewicht', [
        ['leicht', btT('bt_minitools.pc_w_light', 'Bis etwa 100 kg'), btT('bt_minitools.pc_w_light_sub', 'die meisten Möbel- und kleinen Tresore')],
        ['mittel', btT('bt_minitools.pc_w_medium', '100 bis 200 kg'), ''],
        ['schwer', btT('bt_minitools.pc_w_heavy', 'Über 200 kg'), ''],
        ['unklar', btT('bt_minitools.pc_w_unknown', 'Weiß noch nicht'), '']
      ]);

    /* Pro Raum: Urteil und Begruendung. Unabhaengig von der Etage. */
    var R = {
      abstell: [btT('bt_minitools.pc_storage_verdict', 'Sehr gute Wahl'),
        btT('bt_minitools.pc_storage_text', 'Abstellraum und Hauswirtschaftsraum sind die unterschätzten Favoriten. Einbrecher arbeiten unter Zeitdruck und suchen dort, wo sie Wertsachen vermuten, also im Schlafzimmer und im Wohnbereich. Ein Abstellraum steht selten auf dieser Liste. Dazu nutzen Sie Fläche, die sonst brachliegt, und kommen im Alltag trotzdem in Sekunden heran. Wenn Sie die Wahl haben, nehmen Sie diesen Raum.')],
      flur: [btT('bt_minitools.pc_hall_verdict', 'Gute Wahl, mit einer Einschränkung'),
        btT('bt_minitools.pc_hall_text', 'Der Flur ist für Einbrecher unattraktiv, weil dort selten etwas Wertvolles vermutet wird, und er liegt im Alltag auf dem Weg. Der Haken ist ein anderer: Jeder Besucher, Handwerker und Paketbote geht daran vorbei. Ein Tresor, den fremde Menschen regelmäßig sehen, verliert seinen größten Vorteil. Stellen Sie ihn so, dass er von der Wohnungstür aus nicht ins Auge fällt, oder setzen Sie ein Möbel davor.')],
      buero: [btT('bt_minitools.pc_office_verdict', 'Gute Wahl: diskret und im Alltag erreichbar'),
        btT('bt_minitools.pc_office_text', 'Das Arbeitszimmer ist der bewährte Kompromiss aus Diskretion und Bequemlichkeit. Es steht nicht oben auf der Suchliste, und Verträge, Ausweise und Belege liegen genau dort, wo sie gebraucht werden. Zwei Kleinigkeiten: Achten Sie darauf, dass der Tresor nicht im Blickfeld Ihrer Videokonferenzen steht, und dass er vom Fenster aus nicht zu erkennen ist.')],
      schlaf: [btT('bt_minitools.pc_bedroom_verdict', 'Möglich, aber nicht die erste Wahl'),
        btT('bt_minitools.pc_bedroom_text', 'Das Schlafzimmer ist statistisch der Raum, den Einbrecher zuerst durchsuchen, und der Kleiderschrank ist das bekannteste Versteck überhaupt. Das heißt nicht, dass es nicht geht: verankert, verdeckt und von Tür wie Fenster aus nicht sichtbar ist es völlig in Ordnung. Wenn im selben Stockwerk ein Abstellraum zur Verfügung steht, ist der aber die bessere Wahl.')],
      ankleide: [btT('bt_minitools.pc_dressing_verdict', 'Möglich, denken Sie an den Weg dorthin'),
        btT('bt_minitools.pc_dressing_text', 'Eine Ankleide liegt im selben Suchbereich wie das Schlafzimmer, lässt sich dafür aber sehr gut verdecken, etwa hinter Kleidung oder in einem Einbauschrank. Der Punkt, den viele übersehen, ist der Transport: begehbare Schränke haben oft schmale Türen und enge Winkel. Messen Sie Durchgangsbreite und Wendekreis, bevor Sie ein Modell festlegen, sonst steht der Tresor am Ende im Nachbarraum.')],
      wohn: [btT('bt_minitools.pc_living_verdict', 'Nur mit Sichtschutz'),
        btT('bt_minitools.pc_living_text', 'Wohnzimmer haben große Fensterflächen, und genau darüber suchen Einbrecher ihre Ziele aus. Dazu sieht jeder Gast, dass es bei Ihnen etwas zu holen gibt. Wenn es das Wohnzimmer sein soll, dann in einer Ecke ohne Sichtachse von außen und verdeckt durch ein Möbel. Ein Tresor, den niemand kennt, muss gar nicht erst angegriffen werden.')],
      kueche: [btT('bt_minitools.pc_kitchen_verdict', 'Unterschätzt, achten Sie aufs Klima'),
        btT('bt_minitools.pc_kitchen_text', 'In der Küche sucht kaum jemand zuerst, und Platz unter der Arbeitsplatte oder in einem Unterschrank ist oft vorhanden. Dagegen sprechen Wasserdampf, Fett und die Temperaturwechsel beim Kochen und Backen. Beides zusammen setzt Dichtungen, Beschlägen und Elektronik über Jahre zu. Mit ausreichend Abstand zu Herd, Backofen, Spülmaschine und Dunstabzug ist die Küche ein durchaus brauchbarer Platz.')],
      garage: [btT('bt_minitools.pc_garage_verdict', 'Der schwächste der genannten Plätze'),
        btT('bt_minitools.pc_garage_text', 'Drei Dinge sprechen dagegen. In einer Garage arbeitet ein Einbrecher unbeobachtet, hat Zeit und findet dort oft gleich das passende Werkzeug vor. Feuchtigkeit und Temperaturwechsel sind höher als im Haus. Und viele Hausratversicherungen behandeln Nebengebäude gesondert oder schließen sie ganz aus. Diesen dritten Punkt sollten Sie unbedingt vor dem Kauf mit Ihrem Versicherer klären, er entscheidet über den gesamten Schutz.')]
    };

    /* Pro Etage: Fachwissen, keine Warnung. */
    var E = {
      ebenerdig: btT('bt_minitools.pc_floor_ground_text', 'Ebenerdig ist der Transport unkompliziert, und die Tragfähigkeit ist in aller Regel kein Thema. Was hier zählt, ist die Verankerung: sie hält den Tresor an seinem Platz.'),
      keller: btT('bt_minitools.pc_floor_basement_text', 'Im Keller steht der Tresor meist direkt auf der Bodenplatte, damit ist die Frage der Tragfähigkeit ohnehin erledigt. Ihr Augenmerk gehört hier der Luftfeuchtigkeit. Ein einfacher Entfeuchter hält Inhalt und Elektronik dauerhaft trocken.'),
      oben: btT('bt_minitools.pc_floor_upper_text', 'Obere Etagen sind unauffällig und für Einbrecher unbequem, das ist ein echter Vorteil. Den Transport übernimmt unser Team mit dem Treppensteiger, dafür ist es ausgerüstet.'),
      dach: btT('bt_minitools.pc_floor_attic_text', 'Das Dachgeschoss ist der unauffälligste Platz im Haus. Zwei Punkte gehören in die Planung: Im Sommer wird es dort spürbar wärmer, was Batterien schneller altern lässt, und die letzte Treppe ist der aufwendigste Teil des Transports. Beides ist einfach zu berücksichtigen, wenn man es vorher weiß.')
    };

    /* Deckenlast nur in oberen Etagen und nur ab spuerbarem Gewicht. */
    var DECKE = {
      mittel: btT('bt_minitools.pc_ceiling_medium_html', '<b>Ein Punkt zum Abhaken:</b> Wohn- und Büroräume sind nach <code>DIN EN 1991-1-1/NA</code> auf rund 200 kg pro Quadratmeter ausgelegt. Das ist eine Flächenlast und kein Höchstgewicht, und ein Tresor bringt sein Gewicht auf wenig Fläche. In dieser Größenordnung lohnt ein kurzer Blick durch einen Statiker oder Architekten. Beurteilen kann das nur jemand, der die Decke kennt.'),
      schwer: btT('bt_minitools.pc_ceiling_heavy_html', '<b>Ab etwa 200 kg in einer oberen Etage gehört die Decke einmal angeschaut.</b> Das macht ein Statiker oder Architekt vor Ort, aus der Ferne lässt sich das seriös nicht beantworten. Die Grundlage dafür liefern wir Ihnen: exaktes Gewicht, Stellfläche und Aufstandspunkte Ihres Wunschmodells. Damit ist die Prüfung meist an einem Termin erledigt.'),
      unklar: btT('bt_minitools.pc_ceiling_unknown', 'Sobald das Modell feststeht, nennen wir Ihnen Gewicht und Stellfläche. Bis etwa 100 kg ist die Tragfähigkeit erfahrungsgemäß kein Thema, darüber lohnt in oberen Etagen der Blick eines Statikers oder Architekten.')
    };

    mount(slot, 'platz-check', kopf, html, {raum:'abstell', etage:'ebenerdig', gewicht:'leicht'}, [], function(s){
      var r = R[s.raum] || R.abstell;
      var extra = [];
      var obenRaus = (s.etage === 'oben' || s.etage === 'dach');

      if(E[s.etage]) extra.push(E[s.etage]);

      if(obenRaus && s.gewicht !== 'leicht' && DECKE[s.gewicht]){
        extra.push(DECKE[s.gewicht]);
      }

      extra.push(btT('bt_minitools.pc_anchor_html', '<b>Verankern?</b> Keine Pflicht, aber die wirksamste Maßnahme gegen Wegtragen, und Versicherer setzen sie unter 1.000 kg meist voraus. Beton bekommt Bodenanker, bei Fußbodenheizung wird über die Rückwand an eine massive Wand verankert, bei Holzboden ebenfalls. Auch zur Miete rückbaubar. Und immer so stellen, dass der Tresor vom Fenster aus nicht zu erkennen ist.'));

      return {html: box(r[0], r[1], extra,
        cta(btT('bt_minitools.cta_delivery_options', 'Lieferoptionen ansehen'), L.lieferung) + cta2(btT('bt_minitools.cta_start_finder', 'Tresorfinder starten'), L.finder)), ergebnis: s.raum + '/' + s.etage};
    });
  };

  /* ============================ Größe ============================ */
  BT.reg['groesse'] = function(slot){
    var kopf = head(btT('bt_minitools.gr_eyebrow', 'In 2 Fragen zur Größe'), btT('bt_minitools.gr_title', 'Welche Tresorgröße brauche ich?'),
      btT('bt_minitools.gr_intro', 'Rechnen Sie nicht in Litern, sondern in Ordnern. Unsere Modelle sind genau danach ausgewiesen.'));
    var html =
      qBlock(btT('bt_minitools.gr_q1', '1 · Was soll hinein?'), 'inhalt', [
        ['schmuck', btT('bt_minitools.gr_jewellery_cash', 'Schmuck und Bargeld'), ''],
        ['ordner2', btT('bt_minitools.gr_folders2', 'Dokumente bis 2 Ordner'), ''],
        ['ordner8', btT('bt_minitools.gr_folders8', '3 bis 8 Ordner'), ''],
        ['ordner30', btT('bt_minitools.gr_folders30', '9 bis 30 Ordner'), btT('bt_minitools.gr_folders30_sub', 'Akten, Praxis, Büro')],
        ['mehr30', btT('bt_minitools.gr_more30', 'Mehr als 30 Ordner'), btT('bt_minitools.gr_more30_sub', 'Archiv')],
        ['laptop', btT('bt_minitools.gr_laptop', 'Laptop oder Kamera'), '']
      ], true, btT('bt_minitools.hint_all_apply', '(alles antippen, was zutrifft)')) +
      qBlock(btT('bt_minitools.gr_q2', '2 · Puffer für später?'), 'puffer', [
        ['ja', btT('bt_minitools.gr_buffer_yes', 'Lieber eine Nummer größer'), btT('bt_minitools.gr_buffer_yes_sub', 'empfohlen')],
        ['nein', btT('bt_minitools.gr_buffer_no', 'Exakt so viel reicht'), '']
      ]);

    /* Dritter Wert = deutscher Ergebniswert fuers Tracking, bleibt in allen Sprachen gleich. */
    var K = {
      1: [btT('bt_minitools.gr_size1', 'Größe: klein'), btT('bt_minitools.gr_size1_text', 'Etwa 35 bis 60 cm hoch, Platz für Schmuck, Bargeld und bis zu 6 Ordner.'), 'Größe: klein'],
      2: [btT('bt_minitools.gr_size2', 'Größe: mittel'), btT('bt_minitools.gr_size2_text', 'Etwa 60 bis 105 cm hoch, Platz für 8 bis 12 Ordner plus Laptop und Wertsachen.'), 'Größe: mittel'],
      3: [btT('bt_minitools.gr_size3', 'Größe: groß'), btT('bt_minitools.gr_size3_text', 'Etwa 110 bis 185 cm hoch, Platz für bis zu 30 Ordner.'), 'Größe: groß'],
      4: [btT('bt_minitools.gr_size4', 'Größe: extra groß'), btT('bt_minitools.gr_size4_text', 'Ab etwa 150 cm Höhe, 30 bis 50 Ordner, das Format für Akten und Sammlungen.'), 'Größe: extra groß'],
      5: [btT('bt_minitools.gr_size5', 'Größe: riesig (Doppeltürer)'), btT('bt_minitools.gr_size5_text', 'Bis zu 84 Ordner hinter zwei Türen, das Archiv-Format für Kanzlei und Praxis.'), 'Größe: riesig (Doppeltürer)']
    };

    mount(slot, 'groesse', kopf, html, {inhalt:{schmuck:true}, puffer:'ja'}, ['inhalt'], function(s){
      var sel = s.inhalt || {}, rank = 0;
      if(sel.schmuck || sel.ordner2) rank = Math.max(rank, 1);
      if(sel.ordner8 || sel.laptop) rank = Math.max(rank, 2);
      if(sel.ordner30) rank = Math.max(rank, 3);
      if(sel.mehr30) rank = Math.max(rank, 4);
      if(rank === 0) rank = 1;
      if(s.puffer !== 'nein') rank = Math.min(rank + 1, 5);
      var extra = [];
      if(s.puffer !== 'nein') extra.push(btT('bt_minitools.gr_buffer_note_html', 'Der Puffer ist eingerechnet. Der häufigste Satz nach dem Kauf lautet: &bdquo;Hätte ich mal größer gekauft.&ldquo;'));
      return {html: box(K[rank][0], K[rank][1], extra, cta(btT('bt_minitools.gr_cta', 'Tresore dieser Größe ansehen'), L.tresore) + cta2(btT('bt_minitools.cta_start_finder', 'Tresorfinder starten'), L.finder)), ergebnis:K[rank][2]};
    });
  };

  /* ========================= Liefervergleich ========================= */
  BT.reg['liefervergleich'] = function(slot){
    var kopf = head(btT('bt_minitools.lv_eyebrow', 'Kurzer Selbstcheck'), btT('bt_minitools.lv_title', 'Welche Lieferart passt zu Ihnen?'),
      btT('bt_minitools.lv_intro', 'Reine Orientierung. Die endgültige Auswahl treffen Sie ohnehin erst im Checkout.'));
    var cards = '<div class="bt-liefer">'
      + '<div class="bt-liefer__card"><b>' + btT('bt_minitools.lv_kerb_title', 'Versand frei Bordsteinkante') + '</b><em>' + btT('bt_minitools.lv_kerb_badge', 'versandkostenfrei*') + '</em>'
      + '<p>' + btT('bt_minitools.lv_kerb_text', 'Spedition liefert auf Palette bis an die Bordsteinkante. Vertragen und Verankern übernehmen Sie.') + '</p></div>'
      + '<div class="bt-liefer__card"><b>' + btT('bt_minitools.lv_wish_title', 'Lieferung an den Wunschort') + '</b><em>' + btT('bt_minitools.lv_wish_badge', 'Stufentransport, bis zu 5 Fachkräfte') + '</em>'
      + '<p>' + btT('bt_minitools.lv_wish_text', 'Unser Team bringt den Tresor mit Treppensteiger bis an den Platz. Dazu buchbar: Verankerung mit Bescheinigung und Alttresor-Mitnahme.') + '</p></div></div>'
      + '<p class="bt-liefer__fn">' + btT('bt_minitools.lv_footnote_html', '* Liefergebiete, Ausnahmen und was bei Mehraufwand berechnet wird, steht weiter unten unter <a href="#lieferkosten">Kosten und Liefergebiete</a>.') + '</p>';

    var checks = '<div class="bt-calc__q" data-q="check"><div class="bt-calc__qlabel">' + btT('bt_minitools.lv_q', 'Was trifft bei Ihnen zu?') + ' <span class="bt-calc__qhint">' + btT('bt_minitools.lv_q_hint', '(einmal Ja genügt)') + '</span></div><div class="bt-calc__opts">'
      + '<button type="button" class="bt-calc__opt" data-v="treppe" aria-pressed="false">' + btT('bt_minitools.lv_stairs', 'Auf dem Weg zum Platz gibt es Treppen') + '</button>'
      + '<button type="button" class="bt-calc__opt" data-v="schwer" aria-pressed="false">' + btT('bt_minitools.lv_heavy', 'Der Tresor wiegt über 100 kg') + '</button>'
      + '<button type="button" class="bt-calc__opt" data-v="montage" aria-pressed="false">' + btT('bt_minitools.lv_anchoring', 'Die Verankerung soll der Profi machen') + '</button>'
      + '<button type="button" class="bt-calc__opt" data-v="alt" aria-pressed="false">' + btT('bt_minitools.lv_old_safe', 'Ein alter Tresor soll gleich mitgenommen werden') + '</button>'
      + '</div></div>';

    mount(slot, 'liefervergleich', kopf, cards + checks, {check:{}}, ['check'], function(s){
      var c = s.check || {};
      var hinweis = btT('bt_minitools.lv_note', 'Zubehör kommt oft separat als Paket, wundern Sie sich also nicht. Die genaue Zuwegung klären wir vor der Anlieferung telefonisch.');
      if(c.treppe || c.schwer || c.montage || c.alt){
        var extra = [];
        if(c.montage) extra.push(btT('bt_minitools.lv_anchoring_note_html', 'Die <b>Verankerung</b> lässt sich dazubuchen: fachgerecht durch unsere Techniker, mit Bescheinigung für Versicherung und Behörde. Das Verankerungsmaterial ist bei dieser Lieferart enthalten.'));
        if(c.alt) extra.push(btT('bt_minitools.lv_old_safe_note_html', 'Die <b>Alttresor-Mitnahme</b> ebenfalls dazubuchbar: neuer rein, alter diskret mit, ein Termin.'));
        extra.push(hinweis);
        return {html: box(btT('bt_minitools.lv_term_wish', 'Das spricht für Lieferung an den Wunschort'),
          btT('bt_minitools.lv_wish_note', 'Unser Serviceteam bringt den Tresor mit Treppensteiger sicher bis an den Platz, bis zu 5 Fachkräfte.'),
          extra, false), ergebnis:'wunschort'};
      }
      return {html: box(btT('bt_minitools.lv_term_kerb', 'Versand frei Bordsteinkante würde reichen'),
        btT('bt_minitools.lv_kerb_note', 'Ebenerdig und handlich: Die Spedition liefert bis zur Bordsteinkante, mit zwei Helfern steht der Tresor schnell am Platz.'),
        [btT('bt_minitools.lv_kerb_more', 'Sobald Treppen, mehr Gewicht oder Service-Wünsche dazukommen, ist Wunschort die passendere Wahl.'), hinweis],
        false), ergebnis:'bordstein'};
    });
  };

  if(BT.init){ BT.init(); }
  else if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ if(BT.init) BT.init(); }); }
})();